<div class="d-inline-block ml-2" *ngIf="downloadable">
    <button class="btn btn-outline-secondary" type="button" (click)="op.toggle($event)">
        <fa-icon
            [icon]="['far', !loading ? 'file-pdf' : 'spinner']"
            [pulse]="loading" class="mr-2"></fa-icon>
        PDF
        <fa-icon [icon]="['fas', 'caret-down']" class="ml-1"></fa-icon>
    </button>

    <p-overlayPanel #op>
        <ul class="list-group list-group-flush">
            <button
                class="list-group-item list-group-item-action"
                (click)="onDownload()"
            >
                <fa-icon
                    [icon]="['far', !loading ? 'file-download' : 'spinner']"
                    [pulse]="loading" class="mr-2"></fa-icon>
                {{ 'common.download' | translate }} PDF
            </button>
            <button
                class="list-group-item list-group-item-action"
                (click)="onEmail()"
            >
                <fa-icon
                    [icon]="['far', !loading ? 'envelope' : 'spinner']"
                    [pulse]="loading" class="mr-2"></fa-icon>
                {{ 'portal.common.email-file' | translate : { file: 'PDF' } }}
            </button>
        </ul>
    </p-overlayPanel>
</div>
